// SPDX-License-Identifier: AGPL-3.0-or-later
import type {AgentConnection} from '@fluxer/schema/src/domains/konvo/Agents';
import type {I18n} from '@lingui/core';
import {msg} from '@lingui/core/macro';

const STATUS = {
	ready: msg({message: 'Connected', comment: 'Agent account connection status.'}),
	sign_in: msg({message: 'Sign-in required', comment: 'Agent account connection status.'}),
	not_installed: msg({message: 'Tool not found', comment: 'Agent account connection status.'}),
	checking: msg({message: 'Not yet confirmed', comment: 'Agent account connection status.'}),
	disabled: msg({message: 'Disabled in T3 Code', comment: 'Agent account connection status.'}),
	unavailable: msg({message: 'Connection check failed', comment: 'Agent account connection status.'}),
};
const DETAIL = {
	ready: msg({
		message: 'T3 Code confirms this account is signed in and available.',
		comment: 'Agent connection diagnostic explanation.',
	}),
	sign_in: msg({
		message: 'The saved login is no longer usable. Sign in to this account on its machine, then check again.',
		comment: 'Agent connection diagnostic explanation.',
	}),
	not_installed: msg({
		message: 'T3 Code cannot find the configured tool. Check its installation and executable path in T3 Code.',
		comment: 'Agent connection diagnostic explanation.',
	}),
	checking: msg({
		message: 'T3 Code has not confirmed this account’s sign-in. Check again, or run the local status command.',
		comment: 'Agent connection diagnostic explanation.',
	}),
	disabled: msg({
		message: 'This account is still configured. Enable it in T3 Code to use its models.',
		comment: 'Agent connection diagnostic explanation.',
	}),
	unavailable: msg({
		message: 'T3 Code could not complete the check. Check the machine’s network and provider settings, then try again.',
		comment: 'Agent connection diagnostic explanation.',
	}),
};
export const CONNECTIONS_TITLE = msg({
	message: 'Models and connections',
	comment: 'Agent account inventory and diagnostics.',
});
export const CONNECTION_DETAILS = msg({
	message: 'Connection details',
	comment: 'Open agent account diagnostics from the model picker.',
});
export const MACHINE_OFFLINE = msg({
	message: 'Machine offline',
	comment: 'Connection status when the agent machine cannot be reached.',
});
export function connectionLabel(i18n: I18n, status: AgentConnection['status']): string {
	return i18n._(STATUS[status]);
}
export function connectionExplanation(i18n: I18n, status: AgentConnection['status']): string {
	return i18n._(DETAIL[status]);
}
